import React, { useContext, useEffect, useState } from 'react'
import { SocketContext, UserContext } from '../context/UserContext';
import { API_URL_ENDPOINT, BASE_URL } from '../appsetting/appsetting';
import { callAPI } from '../helper/apiHelper';
import { Button, Modal, Offcanvas } from 'react-bootstrap';
import CButton from './CButton';

const Footer = React.memo(({room, isHostOnASeat = false, handleEndCall}) => {
    const { globalUser } = useContext(UserContext);
    const [show, setShow] = useState(false);
    const [requests, setRequests] = useState([]);
    const [layout, setLayout] = useState({});
    const {socket} = useContext(SocketContext);

    const [onSeat, setOnSeat] = useState(false);
    const [requestSent, setRequestSent] = useState(true)


    const [btnload, setbuttonload] = useState(false)
    const [showBook, setShowBook] = useState(false);
    const [content, setContent] = useState([])
    const [contentIndex, setContentIndex] = useState([])
    const [contentBody, setContentBody] = useState({})
    const [muted, setMuted] = useState(0);

    const [isMicOn, setIsMicOn] = useState(false);
    const [loaderBtn, setBtnLoader]=useState(0)
    useEffect(()=>{
      if(globalUser?.isHost){
        getSeatReuest()
      }
      if(!socket) return;
      setRequestSent(globalUser?.SeatRequest)
      setOnSeat(globalUser?.isOnSeat)

      socket.on('seatRequestReceived', handleRequestReceived)
      socket.on('enableRequestButton', () => setRequestSent(false))
      socket.on('toggleMicButton',(action)=>setOnSeat(action))
      socket.on('mic-off-by-host',(userid)=>setIsMicOn(false))

      return () => {
        socket.off('seatRequestReceived')
        socket.off('enableRequestButton')
        socket.off('toggleMicButton')
        socket.off('mic-off-by-host')
      }
    },[globalUser, socket])

    useEffect(()=>{
      getContent()
    },[])

    const toggleSpeaker = () => {
      setMuted((prevMuted) => !prevMuted);
      document.querySelectorAll("audio").forEach((audio) => {
        audio.muted = !muted;
      });
    };

    const toggleMic = () => {
      setIsMicOn((prev) => {
        const newMicStatus = !prev; 
        socket.emit('MicStatusChanged', { userid: globalUser?.ID, status: newMicStatus });
        return newMicStatus;
    });
    }

    const handleRequestReceived = () =>{
      if(globalUser?.isHost){
        getSeatReuest();
      }
    }
    

    const getSeatReuest = async () =>{
      try{
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.SEAT_REQUEST_LIST + `?roomID=${room?.RoomID}`);
        if(response?.data && response?.status){
          setRequests(response.data)
          setLayout(response.layout)
        }else{
          throw new Error(response?.message || "No Request Found")
        }
      }catch(error){
        setRequests([])
        setLayout({})
      }finally{
      }
    }

    const sendSeatRequest = async () => {
      try{
        setbuttonload(true)
        const options = {
          method: 'POST',
          data: {
            userId: globalUser?.ID,
            roomID: room?.RoomID,
          },
        }
        const response = await callAPI(BASE_URL+API_URL_ENDPOINT.SEND_SEAT_REQUEST, options)

        if(response?.status){
          // toast.success(response?.message,toastOption)
          setRequestSent(true);
          socket.emit("seatRequestSend")
        } else {
          throw new Error(response?.message  || 'Failed To Send Request.')
        }
      }catch(error){
        // toast.error(error?.message || "Something Went Wrong.",toastOption)
        setRequestSent(false)
      }finally{
        setbuttonload(false);
      }
    }

    const acceptRequest = async (requestID, userID, action, seatNo = null) =>{
      setBtnLoader(seatNo)
      socket.emit('isUserActive', userID, async (isActive) => {
        console.log(isActive ? "User is online" : "User is offline");
        setbuttonload(true);
        const options = {
          method: 'POST',
          data: {
            userId: userID,
            requestID: requestID,
            roomID : room?.RoomID,
            action : action,
            seatNo,
            isUserActive : isActive
          },
        }
        const response = await callAPI(BASE_URL + API_URL_ENDPOINT.ACTION_ON_REQUEST, options);
        if(response.status){
          const data = {
            userID,
            seatNo,
            action,
            requestID
          }
          socket.emit('RequestAction', data);
        }
        setbuttonload(false)
        setShow(false)
        setTimeout(() => {
          getSeatReuest()
        }, 1000);
        setBtnLoader(0)
      });
    }


    const showSeatRequest = async () => {
      setbuttonload(true)
      await getSeatReuest();
      setbuttonload()
      setShow(true)
    }

    const openBook = () => {
      setShowBook(true)
    }


    const getContent = async() => {
      const response = await callAPI(BASE_URL + API_URL_ENDPOINT.GET_CONTENT)
      setContent(response?.data ?? [])
    }

    const getContentIndex = async(contentID) => {
      const response = await callAPI(BASE_URL + API_URL_ENDPOINT.GET_CONTENT_INDEX + '?contentId='+contentID)
      setContentIndex(response?.data ?? [])
    }

    const getContentBody = async(contentID, contentIndexID = null) => {
      let response;
      if(contentIndexID != null){
        response = await callAPI(BASE_URL + API_URL_ENDPOINT.GET_CONTENT_BODY + '?contentID='+contentID+'&contentIndexID=' + contentIndexID)
      }else{
        response = await callAPI(BASE_URL + API_URL_ENDPOINT.GET_CONTENT_BODY + '?contentID='+contentID)
      }
      setContentBody(response?.data ?? {})
    }

    const contentClick = (id, isIndexBased) => {
      if(isIndexBased == 1){
        //load Index
        getContentIndex(id)
      }else{
        //load Body
        getContentBody(id)
      }
    }

  return (
    <>
      <div className='d-flex justify-content-between pb-2 align-items-center border-bottoms'>
        <div className='d-flex'>
        {/* <div className='d-flex'> */}
          {(globalUser?.isHost && isHostOnASeat)?
            <CButton onClick={showSeatRequest} isLoading={btnload} className='btn-success d-flex'>
              {/* <i className="bi bi-eye-fill me-1"></i> */}
              Seat {requests.length>0 ? <div className='rounded-circle bg-white text-dark ms-2 px-1'>{requests.length.toString().padStart(2, '0')}</div> : ''}
            </CButton>
            : 
            <CButton onClick={sendSeatRequest} disabled={requestSent} isLoading={btnload} className='btn-success d-flex'>
              {/* <i className="bi bi-universal-access-circle me-1"></i>  */}
              {/* <i className="bi bi-columns-gap"></i> */}
              Seat Request
            </CButton>
          }
          <CButton className='btn-light d-flex ms-2' onClick={()=>openBook()}>
            <i className="bi bi-journal-text"></i>
          </CButton>

          {(onSeat || globalUser?.isMainHost)?(
            <CButton className={`${isMicOn ? "bg-white" : "bg-danger"} d-flex ms-2`} onClick={toggleMic}>
              <i style={{fontSize:14}} className={`bi ${isMicOn ? "bi-mic-fill text-success" : "bi-mic-mute-fill text-white"}`}></i>
            </CButton>
          ):''}

          <CButton className="bg-white d-flex ms-2" onClick={toggleSpeaker}>
            <i style={{fontSize:14}} className={`bi ${muted ? "bi-volume-mute-fill text-danger" : "bi-volume-up-fill text-success"}`}></i>
          </CButton>
        </div>
        {/* </div> */}
       <CButton className='btn-danger d-flex ms-2' onClick={()=>handleEndCall(globalUser?.isMainHost,"")}>
        <i className="bi bi-telephone-fill"></i>
        <div className='ms-1'>End</div>
       </CButton>
      </div>
      <div className='text-white text-start mb-1' style={{fontSize:10}}>
        <i className="bi bi-person me-1"></i> {globalUser?.FullName}
      </div>


      <Modal show={show} onHide={()=>setShow(false)}>
        <Modal.Header closeButton className='border-0'>
          <Modal.Title>Seat Request</Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-2 overflow-auto' style={{height:'75vh'}}>
        <div className="accordion" id="accordionExample">
          {requests.length > 0 ? (
            requests.map((item, index) => (
              <div key={index} className="accordion-item">
                <h2 className="accordion-header">
                  <button style={{ fontSize: 14 }} className="p-2 accordion-button shadow-none collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${item?.ID}`} aria-expanded="true" aria-controls={`collapse${item?.ID}`}>
                    {item?.FullName}
                  </button>
                </h2>
                <div id={`collapse${item?.ID}`} className="accordion-collapse collapse " data-bs-parent="#accordionExample">
                  <div className="accordion-body p-2">
                    <div className='d-flex justify-content-between m-2 align-items-center'>
                      <CButton isLoading={loaderBtn === 2} className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload || layout?.SeatB !=0} onClick={() => acceptRequest(item?.ID, item?.UserID, true, 2)}>S2</CButton>
                      <CButton isLoading={loaderBtn === 3} className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload || layout?.SeatC !=0} onClick={() => acceptRequest(item?.ID, item?.UserID, true, 3)}>S3</CButton>
                      <CButton isLoading={loaderBtn === 4} className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload || layout?.SeatD !=0} onClick={() => acceptRequest(item?.ID, item?.UserID, true, 4)}>S4</CButton>
                      <CButton isLoading={loaderBtn === 5} className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload || layout?.SeatE !=0} onClick={() => acceptRequest(item?.ID, item?.UserID, true, 5)}>S5</CButton>
                      <CButton isLoading={loaderBtn === 6} className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload || layout?.SeatF !=0} onClick={() => acceptRequest(item?.ID, item?.UserID, true, 6)}>S6</CButton>
                      <CButton isLoading={loaderBtn === null} className='btn btn-danger btn-sm rounded-circle shadow-none' disabled={btnload} onClick={() => acceptRequest(item?.ID, item?.UserID, false)}><i className="bi bi-x-lg"></i></CButton>
                    </div>
                  </div>
                </div>
              </div>
          ))
          ):(
            <div className="text-center py-2">No requests available</div>
          )}
        </div>
        {/* {requests.length > 0 ? (
            requests.map((row, index) => (
              <div className="rounded py-1 px-2 border shadow-sm mb-2" key={index}>
                <div className="d-flex justify-content-between align-items-center">
                  <div>
                    {index + 1}. <span style={{ fontSize: 14 }}>{row.FullName}</span>
                  </div>
                  <div style={{ fontSize: 30 }} className='d-flex align-items-center'>
                    <button disabled={btnload} className='shadow-none btn-sm btn btn-success me-2' onClick={() => acceptRequest(row.ID, row.UserID, true)}>
                      Accept
                    </button>
                    <button disabled={btnload} className='shadow-none btn-sm btn btn-danger' onClick={() => acceptRequest(row.ID, row.UserID, false)}>
                      Cancel
                    </button>
                    <span style={{fontSize:12}} className=''>Action</span> 
                  </div>
                </div>
                <div className='d-flex justify-content-between mt-2 align-items-center'>
                  <button className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload}>S2</button>
                  <button className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload}>S3</button>
                  <button className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload}>S4</button>
                  <button className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload}>S5</button>
                  <button className='btn btn-success btn-sm rounded-circle shadow-none' disabled={btnload}>S6</button>
                  <button className='btn btn-danger btn-sm rounded-circle shadow-none' disabled={btnload}>S6</button>
                </div>
              </div>
            ))
          ) : (
            <div className="text-center py-2">No requests available</div>
          )} */}
        </Modal.Body>
      </Modal>



      <Offcanvas className='rounded-top h-auto' style={{ maxHeight: '75vh' }} show={showBook} onHide={() => setShowBook(false)} placement="bottom">
        <Offcanvas.Header className=' border-bottom'>
          <Offcanvas.Title className='text-center w-100'>Content</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <>
            {Object.keys(contentBody).length !== 0 ? (
              <div>
                <CButton onClick={() => setContentBody({})} className="btn-secondary">
                  <i className="bi bi-arrow-left-short"></i> Back
                </CButton>
                <p className="fw-bold text-center">{contentBody?.ContentIndexTitle}</p>
                <div className="text-center">{contentBody?.Body}</div>
                <div className="d-flex justify-content-between mt-3">
                  {contentBody?.previousID ? (
                    <button
                      onClick={() => getContentBody(contentBody?.ContentID, contentBody?.previousID)}
                      className="btn btn-sm btn-secondary shadow-none"
                    >
                      <i className="bi bi-caret-left"></i> Previous
                    </button>
                  ) : (
                    <button className="btn btn-sm btn-secondary shadow-none" disabled>
                      <i className="bi bi-caret-left"></i> Previous
                    </button>
                  )}
                  {contentBody?.nextID ? (
                    <button
                      onClick={() => getContentBody(contentBody?.ContentID, contentBody?.nextID)}
                      className="btn btn-sm btn-secondary shadow-none"
                    >
                      Next <i className="bi bi-caret-right"></i>
                    </button>
                  ) : (
                    <button className="btn btn-sm btn-secondary shadow-none" disabled>
                      Next <i className="bi bi-caret-right"></i>
                    </button>
                  )}
                </div>
              </div>
            ) : contentIndex.length > 0 ? (
              <>
                <CButton onClick={() => setContentIndex([])} className="btn-secondary mb-3">
                  <i className="bi bi-arrow-left-short"></i> Back
                </CButton>
                {contentIndex.map((data) => (
                  <div
                    key={data?.ID || data?.ContentID}
                    className="mb-2 mx-1 d-flex justify-content-center align-items-center border rounded py-2"
                    style={{ cursor: "pointer", fontSize: 12 }}
                    onClick={() => getContentBody(data?.ContentID, data?.ID)}
                  >
                    {data?.Title}
                  </div>
                ))}
              </>
            ) : content.length > 0 ? (
              <div className="d-flex w-100 overflow-auto">
                {content.map((data) => (
                  <div
                    key={data?.ID || data?.Title}
                    className="mb-3 mx-3 text-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => contentClick(data?.ID, data?.isIndexBased)}
                  >
                    <img
                      className="border rounded-circle"
                      src={data?.LogoImage ? `data:image/png;base64,${data.LogoImage}` : "/asset/text1.png"}
                      style={{ width: 60, height: 60 }}
                    />
                    <p style={{ fontSize: 10 }} className="mt-1 bg-secondary rounded text-white">
                      {data?.Title || ""}
                    </p>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-3">No content available</div>
            )}
          </>
        </Offcanvas.Body>

      </Offcanvas>

    </>



  )
});

export default Footer